import { render, staticRenderFns } from "./TablePermissionComponent.vue?vue&type=template&id=2e54eee4&"
import script from "./TablePermissionComponent.vue?vue&type=script&lang=js&"
export * from "./TablePermissionComponent.vue?vue&type=script&lang=js&"
import style0 from "./TablePermissionComponent.vue?vue&type=style&index=0&id=2e54eee4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports